var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#EBF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1639 46.6464L57.1732 46.6413H57.1551L46.5288 40.8833L35.8849 35.1152L25.2405 40.8833L14.6143 46.6413H14.5962L14.6054 46.6464L14.5962 46.6515H14.6143L25.2405 52.4094L35.8849 58.1775L46.5288 52.4094L57.1551 46.6515H57.1732L57.1639 46.6464Z",
    fill: "#A0CBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1639 24.5312L57.1732 24.5265H57.1551L46.5288 18.7681L35.8849 13L25.2405 18.7681L14.6143 24.5265H14.5962L14.6054 24.5312L14.5962 24.5362H14.6143L25.2405 30.2946L35.8849 36.0627L46.5288 30.2946L57.1551 24.5362H57.1732L57.1639 24.5312Z",
    fill: "#0C66E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6143 24.0625V47.1151L35.8849 35.589L14.6143 24.0625Z",
    fill: "#BDDBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.155 24.0625V47.1151L35.8848 35.589L57.155 24.0625Z",
    fill: "#BDDBFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.a289cdf4cd4c8a3ea27e8236a8725081.svg";
export { ForwardRef as ReactComponent };